import { Outlet } from "react-router-dom";
import { BoxContainer, Title } from "src/pages/Auth/Forms.styled";
import { useSelector } from "src/redux/hooks";

import { getCurrentVersion } from "../../../../utils";
import {
  DarkBox,
  FooterText,
  Link,
  LoginContainer,
  LoginFooter,
  LogoContainer,
} from "./AuthLayout.styled";

const AuthLayout = () => {
  const { theme, origLogo } = useSelector(state => state.preferencesSlice);
  return (
    <LoginContainer>
      <DarkBox>
        <BoxContainer>
          {theme === "DSNM" ? (
            <LogoContainer>
              {origLogo && <img src="assets/eLogLogoV2.png" />}
              <img src="assets/DSNM White and Gold Logo.png" />
            </LogoContainer>
          ) : (
            <Title>LJ eLogBooks</Title>
          )}
          <Outlet />
        </BoxContainer>
        <LoginFooter>
          <Link to="/privacy-policy">Privacy policy</Link>
          <FooterText>
            © {getCurrentVersion("year")} LJ eLogbooks All rights reserved
            Version {getCurrentVersion()}
          </FooterText>
        </LoginFooter>
      </DarkBox>
    </LoginContainer>
  );
};

export default AuthLayout;
